<template>


  <footer class="relative bg-dark-bgbb100 text-white pt-20 md:pb-6 ipadpro:pb-32">
    <!-- <div
      class="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20 h-20"
      style="transform: translateZ(0);"
    >
      <svg
        class="absolute bottom-0 overflow-hidden"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
        version="1.1"
        viewBox="0 0 2560 100"
        x="0"
        y="0"
      >
        <polygon
          class="text-bg-bgbb100 fill-current"
          points="2560 0 2560 100 0 100"
        ></polygon>
      </svg>
    </div> -->





    <div class="container mx-auto px-4">
      <div class="flex flex-wrap text-center lg:text-left">
        <div class="w-full lg:w-6/12 px-4">
          <h4 class="text-3xl ">Let's keep in touch!</h4>
          <h5 class="text-lg mt-0 mb-2 text-white">
            Find us on any of these platforms, we'll respond shortly.
          </h5>


          <div class="mt-6 lg:mb-0 mb-6">

          
          <li class="flex items-center">
            <a
              class="text-white px-6 py-2 flex items-center text-xs uppercase font-bold"
              href="https://discord.gg/7bVKAPYEkq"
              target="_blank"
            >
              <i class="text-white fab fa-discord text-lg leading-lg text-4xl" />
            </a>

              
            <a
              class="text-white px-6 py-2 flex items-center text-xs uppercase font-bold"
              href="https://t.me/BGBB_Token"
              target="_blank"
            >
              <i class="text-white fab fa-telegram text-lg leading-lg text-4xl" />
            </a>
          
            <a
              class="text-white px-6 py-2 flex items-center text-xs uppercase font-bold"
              href="mailto:bgbb@cyberservices.com"
              target="_blank"
            >
              <i class="text-white fas fa-at text-lg leading-lg text-4xl" />
            </a>
        
        
            <a
              class="text-white px-6 py-2 flex items-center text-xs uppercase font-bold"
              href="https://twitter.com/BgbbToken"
              target="_blank"
            >
              <i class="text-white fab fa-twitter text-lg leading-lg text-4xl" />
            </a>
          </li>                 
          </div>
        </div>


        <div class="w-full lg:w-3/12 px-4">

        <a href="/token">
<p>Token Features</p></a>
<a href="/dapp">
<p>dApp Features</p></a>
<a href="https://github.com/BGBB-token/papers/raw/main/White_Paper_V2.0.pdf"><p>White Paper</p></a>
<a href="https://github.com/BGBB-token/papers/raw/main/Technical_Paper_V2.0.pdf"><p>Technical Paper</p>
</a>
<a href="/FAQ"><p>FAQs</p></a>
        </div>
  <div class="w-full lg:w-3/12 px-4">


<a href="/staking"><p>Staking Dashboard</p>
</a>
<a href="/NFT-marketplace"><p> NFT Marketplace</p></a>

<a href="/BGBB-NFT-marketplace">
<p>BGBB NFT Collection</p></a>

<a href="/Bounty-and-Lottery">

<p>Bounty & Lottery</p></a>

        </div>




      </div>
      <hr class="my-6 border-gray-400" />
      <div
        class="flex flex-wrap items-center md:justify-between justify-center"
      >
        <div class="w-full md:w-4/12 px-4 mx-auto text-center">
          <div class="text-sm text-white py-1">
             {{ date }} Blockchain Gold-Backed Bonds
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      date: new Date().getFullYear(),
    };
  },
};
</script>